<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custOrderNo') || '订单编号'">
              <el-input
                v-model="form.custOrderNo"
                :placeholder="
                  $l('form_placeholder_custOrderNo') || '请输入订单编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_factoryOrderNo') || '工厂订单编号'">
              <el-input
                v-model="form.factoryOrderNo"
                :placeholder="
                  $l('form_placeholder_factoryOrderNo') || '请输入工厂订单编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
              <el-input
                v-model="form.goodsName"
                :placeholder="
                  $l('form_placeholder_goodsName') || '请输入产品名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_masterNcNo') || '成品编码'">
              <el-input
                v-model="form.masterNcNo"
                :placeholder="
                  $l('form_placeholder_masterNcNo') || '请输入成品编码'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_ncNo') || '子件编号'">
              <el-input
                v-model="form.ncNo"
                :placeholder="$l('form_placeholder_ncNo') || '请输入子件编号'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_reworkBy') || '返修人'">
              <dict-select
                v-model="form.listReworkBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_reworkBy') || '请输入返修人'"
                clearable
                filterable
                multiple
              />
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item :label="$l('form_label_reworkProcess') || '返修工序'">
              <el-input
                v-model="form.reworkProcessName"
                :placeholder="
                  $l('form_placeholder_reworkProcessName') || '请输入返修工序'
                "
                clearable
              />
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="12">
            <el-form-item :label="$l('form_label_reworkTech') || '返修工艺'">
              <el-input
                v-model="form.reworkTechName"
                :placeholder="
                  $l('form_placeholder_reworkTechName') || '请输入返修工艺'
                "
                clearable
              />
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="12">
            <el-form-item :label="$l('form_label_reworkProcess') || '返修工序'">
              <dict-select
                v-model="form.listReworkProcess"
                url="/master/common/dict/biz"
                :body="{ dictType: 'pdProcessDictStep' }"
                :placeholder="
                  $l('form_placeholder_reworkProcess') || '请选择返修工序'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="12">
            <el-form-item :label="$l('form_label_reworkTech') || '返修工艺'">
              <dict-select
                v-model="form.listReworkTech"
                url="/master/common/dict/biz"
                :body="{ dictType: 'techChargeUnit' }"
                :placeholder="
                  $l('form_placeholder_reworkTech') || '请选择返修工艺'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_pendingGoodsQualityIssuesStatus') || '复检结果'
              "
            >
              <dict-select
                v-model="form.listPendingGoodsQualityIssuesStatus"
                url="/master/common/dict/biz"
                :body="{ dictType: 'mrpPendingGoodsQualityIssuesStatus' }"
                :placeholder="
                  $l('form_placeholder_pendingGoodsQualityIssuesStatus') ||
                    '请选择复检结果'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_pendingGoodsQualityFinalStatus') || '最终状态'
              "
            >
              <dict-select
                v-model="form.listPendingGoodsQualityFinalStatus"
                url="/master/common/dict/biz"
                :body="{ dictType: 'mrpPendingGoodsQualityFinalStatus' }"
                :placeholder="
                  $l('form_placeholder_pendingGoodsQualityFinalStatus') ||
                    '请选择最终状态'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_firstIssuesTime') || '首次返修时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.firstIssuesTimeStart"
                    :placeholder="
                      $l('form_placeholder_firstIssuesTimeStart') || '开始时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.firstIssuesTimeEnd"
                    :placeholder="
                      $l('form_placeholder_firstIssuesTimeEnd') || '截止时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col> -->

          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_recheckTime') || '复检时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.recheckTimeStart"
                    :placeholder="
                      $l('form_placeholder_recheckTimeStart') || '开始时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.recheckTimeEnd"
                    :placeholder="
                      $l('form_placeholder_recheckTimeEnd') || '截止时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'

// 初始表单
const initForm = () => ({
  keyword: '',
  recheckTimeStart: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
  recheckTimeEnd: dayjs().format('YYYY-MM-DD'),
})
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm() },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm() }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
